export const interviews = [
  {
    id: 1,
    title: "Screening Call",
    description: "Basic screening interview for marketing roles",
    category: "marketing",
    level: "Beginner",
    duration: "10 min",
    credits: "2 credits",
    categoryColor: "text-blue-600 bg-blue-50",
    levelColor: "text-green-600 bg-green-50",
  },
  {
    id: 2,
    title: "E-commerce Strategy",
    description: "Advanced e-commerce marketing strategies",
    category: "marketing",
    level: "Advanced",
    duration: "35 min",
    credits: "7 credits",
    categoryColor: "text-blue-600 bg-blue-50",
    levelColor: "text-red-600 bg-red-50",
  },
  {
    id: 3,
    title: "Discovery Call",
    description: "Learn to conduct effective discovery calls",
    category: "sales",
    level: "Intermediate",
    duration: "25 min",
    credits: "5 credits",
    categoryColor: "text-green-600 bg-green-50",
    levelColor: "text-yellow-600 bg-yellow-50",
  },
];

export const completed = [
  {
    id: 1,
    title: "SEO Interview",
    description: "SEO strategy and implementation",
    date: "2024-01-14",
    category: "marketing",
    score: 85,
    iconColor: "bg-green-100 text-green-600",
    tagColor: "text-blue-600 bg-blue-50",
  },
  {
    id: 2,
    title: "Warm Call Practice",
    description: "Warm calling techniques",
    date: "2024-01-13",
    category: "sales",
    score: 78,
    iconColor: "bg-yellow-100 text-yellow-600",
    tagColor: "text-green-600 bg-green-50",
  },
];

export const practices = [
  {
    id: 1,
    title: "Marketing Fundamentals",
    description: "Practice basic marketing concepts anytime",
    tags: [
      { label: "marketing", color: "text-blue-600 bg-blue-50" },
      { label: "Beginner", color: "text-green-600 bg-green-50" },
    ],
    duration: "20 min",
    credits: 3,
    attempts: 5,
  },
  {
    id: 2,
    title: "Sales Objection Handling",
    description: "Practice handling common sales objections",
    tags: [
      { label: "sales", color: "text-green-600 bg-green-50" },
      { label: "Intermediate", color: "text-yellow-600 bg-yellow-50" },
    ],
    duration: "15 min",
    credits: 4,
    attempts: 3,
  },
];

export const defaultMaterialData = [
  {
    id: 1,
    title: "Meta Advertising Fundamentals",
    description: "Complete guide to Meta advertising",
    category: "marketing",
    categoryColor: "marketing",
    duration: "45 min",
    level: "Beginner",
    rating: 4.8,
    completed: true,
    mediaType: "video",
    ctaText: "Review",
    ctaVariant: "green",
  },
  {
    id: 2,
    title: "Cold Calling Best Practices",
    description: "Master the art of cold calling",
    category: "sales",
    categoryColor: "sales",
    duration: "20 min",
    level: "Intermediate",
    rating: 4.5,
    completed: false,
    mediaType: "article",
    ctaText: "Start Learning",
    ctaVariant: "blue",
  },
  {
    id: 3,
    title: "Google Ads Campaign Structure",
    description: "Advanced Google Ads strategies",
    category: "marketing",
    categoryColor: "marketing",
    duration: "35 min",
    level: "Advanced",
    rating: 4.9,
    completed: false,
    mediaType: "video",
    ctaText: "Start Learning",
    ctaVariant: "blue",
  },
];
export const upcoming = [
  { title: "Paid Ads Interview", time: "Aug 6, 10:00 AM - 7:00 PM" },
  { title: "Cold Call Practice", time: "Jan 17, 2024, 10:30 AM" },
];

export const recent = [
  {
    title: "SEO Interview",
    date: "Jan 14, 2024",
    score: "85%",
    color: "green",
  },
  {
    title: "Warm Call Practice",
    date: "Jan 13, 2024",
    score: "78%",
    color: "yellow",
  },
];
export const achievements = [
  {
    title: "First Interview",
    subtitle: "Completed your first interview",
    color: "yellow",
    icon: "starIcon",
  },
  {
    title: "High Scorer",
    subtitle: "Scored above 80% in an interview",
    color: "green",
    icon: "logo",
  },
  {
    title: "Consistent Learner",
    subtitle: "5-day practice streak",
    color: "blue",
    icon: "clock",
  },
];

export const guidelines = [
  "Ensure you're in a quiet, well-lit environment",
  "Speak clearly and maintain eye contact with the camera",
  "Use specific examples and metrics to support your answers",
  "Take your time to think before responding",
];
export const expect = [
  "The AI interviewer will ask you questions about the topic",
  "You'll have time to think and respond to each question",
  "The interview will be recorded for evaluation",
];
